import type { Locale, Translator } from '@porotutu/i18n'
import { stampedAt } from '@porotutu/i18n'
import type { Column } from './DataTable'

type Stamped = { created_at: string; updated_at?: string }

export function timestampColumns<T extends Stamped>(
  t: Translator,
  locale: Locale,
): Array<Column<T>> {
  return [
    {
      key: 'created_at',
      header: t('table.created_at'),
      sortKey: 'created_at',
      cell: (row) => stampedAt(row.created_at, locale),
    },
    {
      key: 'updated_at',
      header: t('table.updated_at'),
      sortKey: 'updated_at',
      cell: (row) => (row.updated_at === undefined ? '' : stampedAt(row.updated_at, locale)),
    },
  ]
}
